import React from "react";
import { Link, NavLink } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Menu, X, LogOut } from "lucide-react";

export default function Header() {
    const { user, logout } = useAuth();
    const [open, setOpen] = React.useState(false);

    const links = [
        { to: "/", label: "Accueil" },
        { to: "/entreprises", label: "Entreprises" },
        { to: "/devis", label: "Obtenir un devis" },
        { to: "/professionnels", label: "Je cherche des missions" },
        { to: "/blog", label: "Blog" },
    ];

    const dashboardHref =
        user?.role === "admin"
            ? "/admin"
            : user?.role === "candidate"
              ? "/candidat"
              : "/client";

    return (
        <header
            className="glass sticky top-0 z-40"
            data-testid="site-header"
        >
            <div className="max-w-7xl mx-auto flex items-center justify-between px-5 md:px-8 py-4">
                <Link
                    to="/"
                    className="flex items-center gap-2"
                    data-testid="brand-link"
                >
                    <div className="w-9 h-9 rounded-xl bg-[#0B192C] flex items-center justify-center">
                        <span className="text-[#F5A623] font-black text-lg font-display">
                            R
                        </span>
                    </div>
                    <div className="leading-tight">
                        <div className="font-display text-lg font-black tracking-tight">
                            Renforteo
                        </div>
                        <div className="overline text-[10px] tracking-widest">
                            Personnel qualifié · Devis instantané
                        </div>
                    </div>
                </Link>
                <nav className="hidden md:flex items-center gap-8">
                    {links.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            className={({ isActive }) =>
                                `text-sm font-semibold transition-colors ${
                                    isActive
                                        ? "text-[#0B192C]"
                                        : "text-slate-600 hover:text-[#0B192C]"
                                }`
                            }
                            data-testid={`nav-${l.to.replace(/[\/]/g, "-") || "home"}`}
                        >
                            {l.label}
                        </NavLink>
                    ))}
                </nav>
                <div className="hidden md:flex items-center gap-3">
                    {user ? (
                        <>
                            <Link
                                to={dashboardHref}
                                className="btn-ghost-navy text-sm"
                                data-testid="header-dashboard-link"
                            >
                                Mon espace
                            </Link>
                            <button
                                onClick={logout}
                                className="text-slate-500 hover:text-[#0B192C] p-2"
                                data-testid="header-logout-btn"
                                aria-label="Se déconnecter"
                            >
                                <LogOut size={18} />
                            </button>
                        </>
                    ) : (
                        <>
                            <Link
                                to="/connexion"
                                className="btn-ghost-navy text-sm"
                                data-testid="header-login-btn"
                            >
                                Me connecter
                            </Link>
                            <Link
                                to="/devis"
                                className="btn-gold text-sm"
                                data-testid="header-get-quote-btn"
                            >
                                Obtenir mon devis
                            </Link>
                        </>
                    )}
                </div>
                <button
                    className="md:hidden p-2 text-[#0B192C]"
                    onClick={() => setOpen((v) => !v)}
                    data-testid="mobile-menu-toggle"
                    aria-label="Menu"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>
            {open && (
                <div className="md:hidden border-t border-slate-200 bg-white/95">
                    <div className="p-5 flex flex-col gap-3">
                        {links.map((l) => (
                            <NavLink
                                key={l.to}
                                to={l.to}
                                onClick={() => setOpen(false)}
                                className="text-sm font-semibold text-[#0B192C] py-2"
                            >
                                {l.label}
                            </NavLink>
                        ))}
                        {user ? (
                            <>
                                <Link
                                    to={dashboardHref}
                                    className="btn-navy text-center text-sm"
                                >
                                    Mon espace
                                </Link>
                                <button
                                    onClick={logout}
                                    className="btn-ghost-navy text-sm"
                                >
                                    Se déconnecter
                                </button>
                            </>
                        ) : (
                            <>
                                <Link
                                    to="/connexion"
                                    className="btn-ghost-navy text-center text-sm"
                                >
                                    Me connecter
                                </Link>
                                <Link
                                    to="/devis"
                                    className="btn-gold text-center text-sm"
                                >
                                    Obtenir mon devis
                                </Link>
                            </>
                        )}
                    </div>
                </div>
            )}
        </header>
    );
}
